export default "__VITE_ASSET__f66cbcb0__"